module.exports = __webpack_public_path__ + "img/ring_y_i_0_null@3x.852f6737.png";